(function ($) {
	// Hide menu items as they overflow
	var $burgerMenu = $('.burger-menu');
	var $mobileMenu = $('.mobile-menu');

	var disableScroll = function (e) { e.preventDefault(); };

	// Mobile menu toggle
	$burgerMenu.click(function () {
		$burgerMenu.toggleClass('open');
		$mobileMenu.toggleClass('show').removeClass('sub-menu-open');
		$('body').toggleClass('mobile-menu-open');
		$('.sub-menu').removeClass('open');

		if ($burgerMenu.hasClass('open')) {
			// Disable scrolling.
			document.addEventListener('touchmove', disableScroll, { passive: false });
		} else {
			// Enable scrolling.
			document.removeEventListener('touchmove', disableScroll, { passive: false });
		}
	});


	$('.header-btn-log-in').click(function (e) {
		e.preventDefault();
		$('#log-in').modal('show');
	});

	// Mobile menu
	$mobileMenu.find('.has-children').each(function () {
		$(this).click(function (e) {
			e.preventDefault();

			$mobileMenu.toggleClass('sub-menu-open');

			var menuSelector = $(this).attr('data-target');
			$(menuSelector).toggleClass('open');
		});
	});

	$('.mobile-menu-back').click(function () {
		$(this).closest('.sub-menu').removeClass('open');
		$mobileMenu.removeClass('sub-menu-open');
	});
}(jQuery));